import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AoButtonComponent } from '../ao-button/ao-button.component';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [AoButtonComponent],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
})
export class ErrorComponent {
  private router = inject(Router);

  navigateHome() {
    this.router.navigate(['/dashboard']);
  }
}
